import {fetch} from "utils/dataAccess";
export function printExpeditionList(expeditionListId, printerId) {
    return new Promise((resolve, reject) => {
        fetch('/expedition_lists/print/'+expeditionListId, {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                printer_id: printerId,
            })

        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}